export default {
  props: {
    pictures: {
      type: Array,
      required: true,
    },
  },
}
